module.exports = __webpack_public_path__ + "img/card.acc2c576.svg";